import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
// This path assumes Login.jsx is in src/pages/ and CyberAegisLogin.js is in src/components/auth/
import CyberAegisLogin from '../components/auth/CyberAegisLogin';

const LoginPage = () => {
  const { login } = useAuth();

  const handleLogin = async (email, password) => {
    const result = await login(email, password);
    // On success, the ProtectedRoute in App.js will handle the redirect automatically.
    // We just need to return the result to the child component to display errors.
    return result;
  };

  return (
    <div>
      {/* The onLogin prop passes the login function to the UI component */}
      <CyberAegisLogin onLogin={handleLogin} />
      
      {/* This section adds the crucial link to the registration page */}
      {/* <div className="mt-6 text-center text-gray-500 text-sm">
        <p>
          Don't have an account?{' '}
          <Link to="/register" className="font-semibold text-blue-400 hover:text-blue-300">
            Register here
          </Link>
        </p>
      </div> */}
    </div>
  );
};

export default LoginPage;
